import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { $BroadcastManagerService } from '../../_helpers/BroadcastManager.service';

export interface LoaderState {
  show: boolean;
}

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {

  show = false;
  private subscription: Subscription;

  constructor(
    private evt: $BroadcastManagerService
  ) {
    //console.log('loader');
  }

  ngOnInit() {
    console.log("init");
    this.subscription = this.evt.getInstance()
      .subscribe(r => {
        //console.log("r ",r);
        if (r.click === 'SHOW')
          this.show = true;
        else if (r.click === 'HIDE')
          this.show = false;
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
